<fieldset class="d-flex" [disabled]="!service.editable">
	<div class="col-6 px-4">
		<div class="my-3">
			<mat-checkbox [(ngModel)]="service.data.mandatory" [disabled]="!service.editable">Obowiązkowa</mat-checkbox>
		</div>
		<div class="mb-3">
			<ng-select
				id="person_types"
				name="person_types"
				[(ngModel)]="service.data.personTypes"
				placeholder="Typ człowieka dorosły/dziecko"
				[disabled]="!service.editable"
				[multiple]="true"
				required
			>
				<ng-option *ngFor="let item of service.mockData.person_types" [value]="item.id">
					{{ item.name }}
				</ng-option>
			</ng-select>
		</div>
		<div class="mb-3">
			<ng-select
				id="location_whitelist"
				name="location_whitelist"
				[(ngModel)]="service.mockData.location_whitelist"
				placeholder="Destynacje"
				[disabled]="!service.editable"
				[multiple]="true"
				required
			>
				<ng-option *ngFor="let item of service.mockData.locations" [value]="item.id">
					{{ item.name }}
				</ng-option>
			</ng-select>
		</div>
		<div class="mb-3">
			<ng-select
				id="location_blacklist"
				name="location_blacklist"
				[(ngModel)]="service.mockData.location_blacklist"
				placeholder="Wyklucz destynacje"
				[disabled]="!service.editable"
				[multiple]="true"
				required
			>
				<ng-option *ngFor="let item of service.mockData.locations" [value]="item.id">
					{{ item.name }}
				</ng-option>
			</ng-select>
		</div>
		<div class="mb-3">
			<ng-select
				id="services_whitelist"
				name="services_whitelist"
				[(ngModel)]="service.mockData.services_whitelist"
				placeholder="Wymagane inne usługi"
				[multiple]="true"
				[disabled]="!service.editable"
				required
			>
				<ng-option *ngFor="let item of service.mockData.services" [value]="item.id">
					{{ item.name }}
				</ng-option>
			</ng-select>
		</div>
		<div class="mb-3">
			<ng-select
				id="services_blacklist"
				name="services_blacklist"
				[(ngModel)]="service.mockData.services_blacklist"
				placeholder="Wykluczone inne usługi"
				[multiple]="true"
				[disabled]="!service.editable"
				required
			>
				<ng-option *ngFor="let item of service.mockData.services" [value]="item.id">
					{{ item.name }}
				</ng-option>
			</ng-select>
		</div>
		<div class="mb-3">
			<mat-form-field appearance="fill" class="w-100">
				<input
					matInput
					type="number"
					id="daysBeforeDeparture"
					name="daysBeforeDeparture"
					[(ngModel)]="service.data.availableDaysBeforeDeparture"
					[disabled]="!service.editable"
				/>
				<mat-label for="daysBeforeDeparture">Nalicz dni przed</mat-label>
			</mat-form-field>
		</div>
		<div class="mb-3">
			<mat-form-field appearance="fill" class="w-100" matTooltip="Obecnie nieobsługiwane">
				<input
					matInput
					type="number"
					id="amount"
					name="amount"
					[(ngModel)]="service.data.amount"
					[disabled]="true"
				/>
				<mat-label for="amount">Ilość</mat-label>
			</mat-form-field>
		</div>
	</div>

	<div class="col-6 px-4">
		<div class="mb-3">
			<ng-select
				id="kinds"
				name="kinds"
				[(ngModel)]="service.data.kinds"
				placeholder="Rodzaj produktów"
				[disabled]="!service.editable"
				[multiple]="true"
				required
			>
				<ng-option *ngFor="let item of service.mockData.kinds" [value]="item.id">
					{{ item.name }}
				</ng-option>
			</ng-select>
		</div>
		<div class="mb-3">
			<ng-select
				id="product_whitelist"
				name="product_whitelist"
				[(ngModel)]="service.mockData.product_whitelist"
				placeholder="Produkty"
				[disabled]="!service.editable"
				[multiple]="true"
				required
			>
				<ng-option *ngFor="let item of service.mockData.products" [value]="item.id">
					{{ item.name }}
				</ng-option>
			</ng-select>
		</div>
		<div class="mb-3">
			<ng-select
				id="product_blacklist"
				name="product_blacklist"
				[(ngModel)]="service.mockData.product_blacklist"
				placeholder="Wyklucz produkty"
				[disabled]="!service.editable"
				[multiple]="true"
				required
			>
				<ng-option *ngFor="let item of service.mockData.products" [value]="item.id">
					{{ item.name }}
				</ng-option>
			</ng-select>
		</div>
		<div class="mb-3">
			<ng-select
				id="count_services_whitelist"
				name="count_services_whitelist"
				[(ngModel)]="service.mockData.count_services_whitelist"
				placeholder="Oblicz % od usługi"
				[disabled]="!service.editable"
				[multiple]="true"
				required
			>
				<ng-option *ngFor="let item of service.mockData.services" [value]="item.id">
					{{ item.name }}
				</ng-option>
			</ng-select>
		</div>
		<div class="mb-3">
			<ng-select
				id="count_services_blacklist"
				name="count_services_blacklist"
				[(ngModel)]="service.mockData.count_services_blacklist"
				placeholder="Nie licz % od usługi"
				[disabled]="!service.editable"
				[multiple]="true"
				required
			>
				<ng-option *ngFor="let item of service.mockData.services" [value]="item.id">
					{{ item.name }}
				</ng-option>
			</ng-select>
		</div>
		<div class="mb-3">
			<ng-select
				id="channels"
				name="channels"
				[(ngModel)]="service.data.sellChannels"
				placeholder="Kanał sprzedaży"
				[disabled]="!service.editable"
				[multiple]="true"
				required
			>
				<ng-option *ngFor="let item of service.mockData.channels" [value]="item.id">
					{{ item.name }}
				</ng-option>
			</ng-select>
		</div>
	</div>
</fieldset>
